import { Grid, Container } from '@mui/material';
import Cancel from '@mui/icons-material/Cancel';
import * as ShotSelection from '../classes/ShotSelection';

export default function FittingShotHistory(props: any) {
    let rows = props.rows as ShotSelection.ShotHistory[];
    let callback = props.callback;
    const intl = props.intl;

    return (
        <>
            <Container maxWidth='lg' sx={{ display: {xs: 'none', sm: 'grid'}, marginTop: '0px' }} className='your-shots'>

                <Grid container spacing={2} className='fitting-grid' style={{
                    display: 'grid', borderRadius: '5px', borderStyle: 'solid', borderWidth: '1px', borderColor: 'lightgray',
                }}>
                    <div style={{
                        display: 'grid', gridTemplateColumns: '7% 4% 10% 12% 12% 12% 13% 11% 13% 6%'
                    }}>

                        <div className='header' style={{ gridColumnStart: '1' }} >{intl.formatMessage({ id: "now.hitting.shot.number" })}</div>
                        <div className='header' style={{ gridColumnStart: '2' }}>{intl.formatMessage({ id: "now.hitting.loft" })}</div>
                        <div className='header' style={{ gridColumnStart: '3' }} >{intl.formatMessage({ id: "now.hitting.shot.type" })}</div>
                        <div className='header' style={{ gridColumnStart: '4' }}>{intl.formatMessage({ id: "now.hitting.head" })}</div>
                        <div className='header' style={{ gridColumnStart: '5' }} >{intl.formatMessage({ id: "now.hitting.attack.angle" })}</div>
                        <div className='header' style={{ gridColumnStart: '6' }}>{intl.formatMessage({ id: "now.hitting.ball" })}</div>
                        <div className='header' style={{ gridColumnStart: '7' }} >{intl.formatMessage({ id: "now.hitting.launch" })}</div>
                        <div className='header' style={{ gridColumnStart: '8' }}>{intl.formatMessage({ id: "now.hitting.backspin" })}</div>
                        <div className='header' style={{ gridColumnStart: '9' }} >{intl.formatMessage({ id: "now.hitting.carry" })}</div>
                        <div className='header' style={{ gridColumnStart: '10' }}>&nbsp;</div>
                    </div>

                    {rows.map((row, ix) => {
                        return (
                            <div className='fitting-grid row' key={ix} style={{ 
                                display: 'grid', gridTemplateColumns: '7% 4% 10% 12% 13% 12% 13% 11% 13% 6%'
                            }}>
                                <div className='cell thin'>{row.shotNumber}</div>
                                <div className='cell thin'>{row.loft}</div>
                                <div className='cell thin'>{row.shotType}</div>
                                <div className='cell thin'>{row.headSpeed}</div>
                                <div className='cell wide'>{row.attackAngle}</div>
                                <div className='cell wide'>{row.ballSpeed}</div>
                                <div className='cell wide'>{row.launchAngle}</div>
                                <div className='cell thin'>{row.backSpin}</div>
                                <div className='cell wide'>{row.carryDistance}</div>
                                <div className='cell wide cancel'><Cancel onClick={() => callback(row.id)}></Cancel></div>
                            </div>
                        )
                    })}
                </Grid>
           </Container>
        </>
    );
}